export const integrationsData = {
  hero: {
    title: "INTEGRATIONS",
    subTitle: "Unlock your product's full potential with 1,000+ pre-built Connectors",
    description: "Expand your market reach and go-to market faster using our pre-built connectors, or configure your own Custom Integrations."
  },
  contentCallout: {
    title: "Can't find the connector you need?",
    card: {
      title: "Build your own connector",
      description: "Use Cobalt's API to build your custom integration, all while maintaining a native, embedded experience for your users."
    },
    cta: {
      text: "Schedule a call",
      href: "https://cal.com/cobalt/welcome-to-cobalt"
    }
  },
  cta: {
    title: "The future of software is seamlessly Integrated",
    description: "Be ready with Cobalt's embedded integration platform",
    cta: {
      text: "Get Started",
      href: "/signup",
      secondary: {
        text: "Book a Demo",
        href: "https://cal.com/cobalt/welcome-to-cobalt"
      }
    }
  }
};